'use client';

import { Suspense } from 'react';
import GlobalSearch from './GlobalSearch';

export default function GlobalSearchWrapper() {
  return (
    <Suspense fallback={<div style={{ width: '100%', height: '40px' }} />}>
      <GlobalSearch />
    </Suspense>
  );
}
